import { MantineThemeOverride } from '@mantine/core';

export type HoverCardTheme = NonNullable<MantineThemeOverride['components']>['HoverCard'];

export const HoverCard: HoverCardTheme = {
  // todo: define
};
